// Step 8.5 Half A0 commit 0.2: shared Tailwind class strings for the
// signup wizard. Hard-coded brand teal #77C1BB (matches the mockup
// design system) so the wizard renders correctly even before the
// app's Tailwind theme is migrated to the Jun 8 palette.

export const fieldClass =
  "h-11 w-full rounded-md border border-zinc-300 bg-white px-3 text-base text-zinc-900 focus-visible:border-[#77C1BB] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#77C1BB]/15";

export const textareaClass =
  "w-full rounded-md border border-zinc-300 bg-white px-3 py-2 text-base text-zinc-900 focus-visible:border-[#77C1BB] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#77C1BB]/15";

export const labelClass =
  "mb-5 block text-sm font-semibold text-zinc-900";

export const primaryButtonClass =
  "rounded-md bg-[#77C1BB] px-6 py-3 text-base font-semibold text-white shadow-sm transition-colors hover:bg-[#67b1ab] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#77C1BB] disabled:cursor-not-allowed disabled:opacity-60";

export const secondaryButtonClass =
  "rounded-md border border-zinc-300 bg-white px-6 py-3 text-base font-medium text-zinc-900 transition-colors hover:bg-zinc-50";

export const radioCardClass =
  "cursor-pointer rounded-md border border-zinc-300 bg-white px-4 py-3 text-center text-sm font-medium text-zinc-700 transition-colors hover:border-[#77C1BB]";

export const radioCardSelectedClass =
  "cursor-pointer rounded-md border border-[#77C1BB] bg-[#f0f9f8] px-4 py-3 text-center text-sm font-semibold text-zinc-900";
